<template>
  <div>
    <div v-if="!locked">
      <slot />
    </div>
    <p v-else class="mb-0">
      <em>{{ reference }} is currently saved</em>
      <!-- <ak-text-link @click="$emit('onUnlock')">
        <strong class="color-primary">click here to replace</strong>
      </ak-text-link> -->
      <!-- <ak-button
        class="ml-small"
        :color="'primary'"
        :size="'tiny'"
        @click="$emit('onUnlock')"
      >
        <ak-icon :type="'edit'" class="mr-tiny"></ak-icon>
        Edit
      </ak-button> -->
      <ak-tooltip class="ml-tiny">
        <template #trigger>
          <ak-button
            class="operations-list__action"
            color="white"
            size="small"
            circle
            @click="$emit('onUnlock')"
          >
            <ak-icon type="edit" color="grey-light" />
          </ak-button>
        </template>
        Replace {{ reference }}
      </ak-tooltip>
    </p>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import TextLink from '@akerolabs/akero-vue/src/components/textLink/TextLink.vue'

export default defineComponent({
  name: 'AkIntegrationSFTPProfileSavedField',
  components: {
    [TextLink.name]: TextLink,
  },
  props: {
    locked: {
      default: false,
      type: Boolean,
    },
    reference: {
      required: true,
      type: String,
    },
  },
  emits: ['onUnlock'],
})
</script>
